import React, { useState, useEffect } from 'react';

import './styles.css';

import eventServices from '../../../services/academy/eventServices';
import trainingsServices from '../../../services/academy/trainingsServices';

import compare from '../../../functions/compare';

import { Dots } from "react-activity";

import formatTime from '../../../functions/formatTime';
import formatDate from '../../../functions/formatDate';
import MainView from '../../../components/MainView';
import NavHistory from '../../../components/NavHistory';
import CalendarDay from './CalendarDay';
import CalendarCard from './CalendarCard';
import PopupNewEvent from './PopupNewEvent';
import { FaRegCalendarPlus } from 'react-icons/fa';

export default function Calendar(props) {
    const [date, setDate] = useState('');
    const [selectedDate, setSelectedDate] = useState(null);
    const [events, setEvents] = useState([]);
    const [popupNewEventVisible, setPopupNewEventVisible] = useState(false);
    const [uploading, setUploading] = useState(false);

    useEffect(() => {
        changeDate(new Date());
    }, []);

    useEffect(() => {
        if (selectedDate)
            readEventsAndTrainings(selectedDate.toISOString().split('T')[0]);
    }, [selectedDate]);

    async function readEventsAndTrainings(date) {
        let array;
        setUploading(true);
        let response = await eventServices.getEvents(date);
        if (response.status === 200) {
            // setEvents(response.data.sort((a, b) => compare(`${a.data}${a.hora_inicio}${a.hora_fim}`, `${b.data}${b.hora_inicio}${b.hora_fim}`)));
            array = response.data;
            response = await trainingsServices.getAcademyTrainings(date);
            if (response.status === 200) {
                array = [...array, ...response.data];
            } else
                alert("Erro ao ler treinos, tente novamente!");
            setEvents(array.sort((a, b) => compare(`${a.data}${a.hora_inicio}${a.hora_fim}`, `${b.data}${b.hora_inicio}${b.hora_fim}`)));
            console.log(array.sort((a, b) => compare(`${a.data}${a.hora_inicio}${a.hora_fim}`, `${b.data}${b.hora_inicio}${b.hora_fim}`)));
        } else
            alert("Erro ao ler eventos, tente novamente!");
        setUploading(false);
    };

    function onDelete(index, array = events, setArray = setEvents) {
        setArray([...array.slice(0, index), ...array.slice(index + 1, array.length)]);
    }

    function getDaysOfMonth(year, month) {
        month--;
        var auxDate = new Date(year, month);
        var days = [];
        while (auxDate.getMonth() === month) {
            days.push(new Date(auxDate.getTime()));
            auxDate.setDate(auxDate.getDate() + 1);
        }
        return days;
    }

    function changeDate(newDate) {
        setDate(`${newDate.getFullYear()}-${formatTime(newDate.getMonth() + 1)}`);
        setSelectedDate(newDate);
        let scrollDayWidth = 88;
        let goalScroll = scrollDayWidth * (newDate.getDate() - 3);
        setTimeout(() => {
            document.querySelector('.calendar-days').scrollLeft = goalScroll;
        }, 200);
    }

    return (
        <MainView currentPage='calendar' coachMenu={props.coachMode}>
            <NavHistory navPages={['Calendário']} />

            <div className='calendar-page-options'>
                <input
                    type="month"
                    value={date}
                    pattern="[0-9]{4}-[0-9]{2}"
                    onChange={(event) => { setDate(event.target.value) }}
                />

                <div className='calendar-page-options-group'>
                    <button
                        className='today'
                        onClick={() => changeDate(new Date())}
                    >Hoje</button>

                    {
                        props.coachMode ?
                            [] :
                            <>
                                <button className='new-event' onClick={() => setPopupNewEventVisible(true)}>Adicionar evento<FaRegCalendarPlus /></button>
                                <PopupNewEvent
                                    visibility={popupNewEventVisible}
                                    setVisibility={setPopupNewEventVisible}
                                    onCreate={readEventsAndTrainings}
                                />
                            </>
                    }
                </div>

            </div>
            <ul className="calendar-days">
                {
                    date.length ?
                        getDaysOfMonth(date.slice(0, 4), date.slice(5)).map((item, index) =>
                            <CalendarDay
                                key={index}
                                day={item}
                                selectedDate={selectedDate}
                                changeDate={changeDate}
                            />
                        )
                        : []
                }
            </ul>
            <hr />

            <ul className="calendar-cards">
                <div>
                    {
                        uploading ?
                            <Dots />
                            : <p>{events && events.length ? "Eventos do" : "Não há nenhum evento no"} dia <b>{selectedDate ? `${formatTime(selectedDate.getDate())} de ${formatDate(selectedDate.getMonth() + 1)} de ${selectedDate.getFullYear()}` : '...'}</b></p>
                    }
                </div>
                {
                    events.map((item, index) =>
                        <CalendarCard
                            key={item.id}
                            id={item.id}
                            tittle={item.titulo ? item.titulo : `Treino ${item.frequencia}`}
                            description={item.descricao}
                            class={item.turma}
                            block={item.bloquear}
                            date={item.data}
                            startTime={item.hora_inicio}
                            endTime={item.hora_fim}
                            canDelete={item.titulo ? true : false}
                            onDelete={() => onDelete(index)}
                            coachMode={props.coachMode}
                        />
                    )
                }
            </ul>
        </MainView>
    )
}